import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Seo from "../../components/Seo";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(form.email, form.password);
    setSubmitting(false);
    if (!res.ok) {
      toast.error(res.error);
      return;
    }
    if (res.user.role !== "admin") {
      toast.error("Admin access required");
      return;
    }
    toast.success("Signed in to studio");
    navigate("/admin", { replace: true });
  };

  return (
    <main className="admin-login-page">
      <Seo title="Studio Login" description="Private Lalita Soujanya administration login." robots="noindex, nofollow" />
      <div className="admin-login-card">
        <span className="eyebrow">Studio access</span>
        <h1>
          House <em>admin.</em>
        </h1>
        <p>Sign in to manage products, orders and brand content.</p>
        <form onSubmit={submit}>
          <label>
            Email
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="admin-login-email-input"
              autoComplete="email"
            />
          </label>
          <label>
            Password
            <input
              required
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="admin-login-password-input"
              autoComplete="current-password"
            />
          </label>
          <button
            className="button dark-button full"
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit-button"
          >
            {submitting ? "Signing in…" : "Sign in"} <ArrowUpRight size={16} />
          </button>
        </form>
      </div>
    </main>
  );
}
